export default __webpack_public_path__ + "static/media/nfo-banner-it-telecom-comp-mobile.54af08c5.jpg";